<section>
    <mat-list>
        <div mat-subheader>{{ 'equipment.recorder' | transloco }}</div>
        <mat-divider></mat-divider>
        <mat-list-item *ngFor="let recorder of getTranslation('equipment.recChildren')">
            <span mat-line>{{ recorder }}</span>
        </mat-list-item>
        <div mat-subheader>{{ 'equipment.mixer' | transloco }}</div>
        <mat-divider></mat-divider>
        <mat-list-item *ngFor="let mixer of getTranslation('equipment.mixChildren')">
            {{ mixer }}
        </mat-list-item>
        <div mat-subheader>{{ 'equipment.wireless' | transloco }}</div>
        <mat-divider></mat-divider>
        <mat-list-item *ngFor="let wireless of getTranslation('equipment.wireChildren')">
            {{ wireless }}
        </mat-list-item>
        <div mat-subheader>{{ 'equipment.mikesWireless' | transloco }}</div>
        <mat-divider></mat-divider>
        <mat-list-item *ngFor="let mikes of getTranslation('equipment.mikesChildren')">
            {{ mikes }}
        </mat-list-item>
        <div mat-subheader>{{ 'equipment.monitoring' | transloco }}</div>
        <mat-divider></mat-divider>
        <mat-list-item *ngFor="let monitor of getTranslation('equipment.monitorChildren')">
            {{ monitor }}
        </mat-list-item>
        <div mat-subheader>{{ 'equipment.microphones' | transloco }}</div>
        <mat-divider></mat-divider>
        <mat-list-item *ngFor="let micro of getTranslation('equipment.micsChildren')">
            {{ micro }}
        </mat-list-item>
        <div mat-subheader>{{ 'equipment.accessories' | transloco }}</div>
        <mat-divider></mat-divider>
        <mat-list-item *ngFor="let acc of getTranslation('equipment.accChildren')">
            {{ acc }}
        </mat-list-item>
    </mat-list>
</section>